// export const pkuRed = "#94070a";
export const pkuRed = "#AF1D20";
// export const bodyBg = "#f5efe7";
export const bodyBg = "#FFE8E7";
export const splitColor = "#B26F6F";
export const footerColor = "#333";
export const bannerTextColor = "#AF1D20";